import React, { useState, useEffect } from "react";
import { setKey, setStringifiedKey, clearKeys } from "../store/actions";
import { connect } from "react-redux";
import { Link, NavLink, Redirect } from "react-router-dom";
import userService from "../services/user";
import subscriptionService from "../services/subscription";
import utils from "../utils/utils";
import keys from "../store/keys";
import Cookies from 'universal-cookie';

function Signup({ session, setKey, clearKeys, setStringifiedKey, ...props }) {

	const [firstname, setFirstname] = useState('');
	const [lastname, setLastname] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [dob, setDoB] = useState('');
	const [signupForEmails, setSignupForEmails] = useState(true);
	const [errorMessage, setErrorMessage] = useState('');
	const [successMessage, setSuccessMessage] = useState('');
	const [redirectTo, setRedirectTo] = useState(null);

	useEffect(() => {
		if (session.isLoggedIn) {
			setRedirectTo("/");
		}
		else {
			clearKeys();
		}
	}, []);

	const handleSubmit = e => {
		e.preventDefault();
		if (!email || !password || !firstname || !lastname || !dob) {
			setErrorMessage(`Please provide all fields.`);
			return;
		}
		if (!utils.isValidEmail(email)) {
			setErrorMessage(`Please provide a valid email address.`);
			return;
		}

		setKey(keys.isLoading, true);
		userService.signup({ firstname, lastname, email, password, dob })
			.then(result => {
				if (result.error) {
					setErrorMessage(result.error);
					setKey(keys.isLoading, false);
					return;
				}

				setErrorMessage('');
				setSuccessMessage(`Signup successfully! Please check your mailbox to activate your account.`);
				setKey(keys.isLoading, false);

				if(signupForEmails) {
					subscriptionService.signup({email: email});
				}
			});
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			<div className="container container-small">
				<h4 className="mt-50">Register</h4>
				<form onSubmit={handleSubmit}>
					<div className="form-group mt-20 mb-3">
						<label htmlFor="txtEmail" className="form-label">
							Email address
						</label>
						<input
							className="form-control shadow-none"
							type="email"
							placeholder="johndoe@gmail.com"
							required="required"
							id="txtEmail"
							value={email}
							onChange={e => setEmail(e.target.value)}
						/>
					</div>
					<div className="form-group mb-3">
						<label htmlFor="txtPassword" className="form-label">
							Password
						</label>
						<input
							className="form-control shadow-none"
							type="password"
							placeholder="*******"
							required="required"
							id="txtPassword"
							value={password}
							onChange={e => setPassword(e.target.value)}
						/>
					</div>
					<div className="form-group mb-3">
						<label htmlFor="txtFirstname" className="form-label">
							First name
						</label>
						<input
							className="form-control shadow-none"
							type="text"
							placeholder="John"
							required="required"
							id="txtFirstname"
							value={firstname}
							onChange={e => setFirstname(e.target.value)}
						/>
					</div>
					<div className="form-group mb-3">
						<label htmlFor="txtLastname" className="form-label">
							Last name
						</label>
						<input
							className="form-control shadow-none"
							type="text"
							placeholder="Doe"
							required="required"
							id="txtLastname"
							value={lastname}
							onChange={e => setLastname(e.target.value)}
						/>
					</div>
					<div className="form-group mb-3">
						<label htmlFor="txtDob" className="form-label">
							Date of birth
						</label>
						<input
							className="form-control shadow-none"
							type="date"
							placeholder="Doe"
							required="required"
							id="txtDob"
							value={dob}
							onChange={e => setDoB(e.target.value)}
						/>
					</div>
					<div className="row">
						<div className="col">
							{errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
							{successMessage && <div className="text-success mb-3">{successMessage}</div>}
						</div>
					</div>
					<div className="row">
						<div className="col-1 mt-10">
							<input
								className="form-input"
								type="checkbox"
								defaultValue={true}
								checked={signupForEmails}
								onClick={() => setSignupForEmails(document.getElementById('flexCheckDefault').checked)}
								id="flexCheckDefault" />
						</div>
						<div className="col-11">
							<div className="signup-emails" style={{ marginLeft: -10 }}>
								<div style={{ fontSize: 13 }}>Signup for style news and offers.</div>
								<div style={{ marginTop: -10 }}><NavLink to="#" className="btn btn-link" style={{ textDecoration: 'underline', fontSize: 13 }}>What will I receive?</NavLink></div>
							</div>
						</div>
						<div className="col-12 policies">
							<p style={{ fontSize: 10, color: "#6d6d6d" }}>By registering, your account will be subject to the <a target="_blank" href="#">Terms and Conditions</a> and <a target="_blank" href="#">Privacy Policy.</a></p>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<button
								type="submit"
								className="btn btn-dark shadow-none w-100 mb-3"
								onClick={handleSubmit}>
								Create Account
							</button>
						</div>
					</div>

					<hr />
					<div className="row text-center mt-30">
						<div className="col">
							<p>Already have account?</p>
							<NavLink to="/login" className="btn btn-outline-dark mt-10 w-100">
								Sign In
							</NavLink>
						</div>
					</div>
				</form>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
	clearKeys: () => dispatch(clearKeys()),
	setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Signup);
